enum ButtonTheme {
  Primary = "Primary",
}

export default ButtonTheme;
